import type { TimeZone } from '@shared/utils/date';
import { parseInTimeZone } from '@shared/utils/date';
import { formatISO } from 'date-fns';
import type { DateRange } from '../types';

export type DateTimePrecision = 'minute' | 'second';

export function getPrecision(range: DateRange): DateTimePrecision {
  return range.to.getTime() - range.from.getTime() < 60000
    ? 'second'
    : 'minute';
}

export function toInputFormat(date?: Date, precision?: DateTimePrecision) {
  if (!isValidDate(date)) {
    return '';
  }

  const length = precision === 'second' ? 19 : 16;

  return formatISO(date).substring(0, length);
}

export function fromInputFormat(dateString: string, timeZone?: TimeZone): Date {
  return typeof timeZone === 'string'
    ? parseInTimeZone(dateString, timeZone)
    : new Date(dateString);
}

export function parseInputRange({
  from,
  to,
  timeZone,
}: {
  from: string;
  to: string;
  timeZone?: TimeZone;
}) {
  try {
    const range = {
      from: fromInputFormat(from, timeZone),
      to: fromInputFormat(to, timeZone),
    };

    if (!isValidDate(range.from) || !isValidDate(range.to)) {
      return;
    }

    return range;
  } catch {
    return;
  }
}

function isValidDate(date?: Date): date is Date {
  return date instanceof Date && !isNaN(date.getTime());
}
